import { Injectable } from '@angular/core';
import { appVersion } from 'src/environments/app-version';

export interface IAppInfo {
  version: string;
}

@Injectable({
  providedIn: 'root',
})
export class AppInfoService {
  private readonly _appInfo: IAppInfo = {
    version: appVersion,
  };

  public get appInfo(): IAppInfo {
    return this._appInfo;
  }

  public get version(): string {
    return this._appInfo.version;
  }
}
